module.exports = "/_next/static/images/img-mobile-hiring-faces-bottom-2bc4b93a32cdf99e7431025b8c30a435.png";